export enum SpinnerDataHooks {
  Main = 'spinner-wrapper',
}
